__turbopack_context__.v({
  "chevron": "PhoneInput-module__OZcaAG__chevron",
  "chevronOpen": "PhoneInput-module__OZcaAG__chevronOpen",
  "container": "PhoneInput-module__OZcaAG__container",
  "dial": "PhoneInput-module__OZcaAG__dial",
  "dialButton": "PhoneInput-module__OZcaAG__dialButton",
  "disabled": "PhoneInput-module__OZcaAG__disabled",
  "dropdown": "PhoneInput-module__OZcaAG__dropdown",
  "dropdownItem": "PhoneInput-module__OZcaAG__dropdownItem",
  "dropdownWrapper": "PhoneInput-module__OZcaAG__dropdownWrapper",
  "flag": "PhoneInput-module__OZcaAG__flag",
  "inputRow": "PhoneInput-module__OZcaAG__inputRow",
  "itemCode": "PhoneInput-module__OZcaAG__itemCode",
  "itemDial": "PhoneInput-module__OZcaAG__itemDial",
  "itemFlag": "PhoneInput-module__OZcaAG__itemFlag",
  "numberInput": "PhoneInput-module__OZcaAG__numberInput",
  "selected": "PhoneInput-module__OZcaAG__selected",
});
